import '@commons/polyfills';
import '@commons/reset';
import '@commons/general';
import '@commons/header';
import '@commons/utils';

import carousel from '@modules/carousel';
import lightBox from '@modules/lightBox';
import socialShare from '@modules/socialShare';

// Blog styles
import '@styles/layouts/l-blog-listing.scss';
import '@styles/layouts/l-blog-listing-workbench.scss';
import '@styles/components/c-article-header.scss';
import '@styles/components/c-article.scss';
import '@styles/components/c-fullwidth-image-carousel.scss';
import '@styles/components/c-blog-topics.scss';
import '@styles/components/c-pagination.scss';
import '@styles/components/c-rounded-grid.scss';

export default function init() {
  carousel();
  lightBox();
  socialShare();

}

init();
